export default "__VITE_ASSET__CpyZ34ZI__"